export const subcategoryCarousel = {
    '.slick-slider': {
        alignItems: 'center',
        position: 'relative'
    },
    '.slick-track': {
        display: 'flex',
        paddingRight: {base: '15%', sm: '5%', md: '0'}
    },
    '.slick-list': {
        overflow: 'hidden',
        margin: '0 1px',
        padding: '3px'
    },
    '.slick-arrow': {
        top: '50%',
        transform: 'translateY(-50%)'
    },
    '.slick-arrow.slick-prev': {
        transform: 'translateY(-50%) rotate(180deg)'
    },
    '.slick-arrow.slick-disabled': {
        display: 'none !important'
    }
}
